module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-E-drill-received-shadow.89ffc2e9.png";